import React from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { formatDownloads } from '../../../utils/numberUtils';

const CompetitorsModal = ({ show, handleClose, competitors, keyword }) => {
  const navigate = useNavigate();

  // Get competitor details with game information
  const getCompetitorItems = () => {
    if (!competitors) return [];

    return competitors
      .map(competitor => ({
        itemId: competitor.item_id,
        downloads: competitor.downloads,
        name: competitor.name || 'Unknown Game',
        imageUrl: competitor.image_url
      }));
  };

  const handleGameClick = (itemId) => {
    // Close the modal first
    handleClose();
    // Navigate to the game dashboard
    navigate(`/xr/app?id=${itemId}`);
  };

  const competitorItems = getCompetitorItems();

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className="competitors-modal">
      <Modal.Header closeButton style={{
        background: 'linear-gradient(135deg, #808080 0%, #764ba2 100%)',
        borderBottom: 'none',
        borderRadius: '12px 12px 0 0'
      }}>
        <Modal.Title style={{ color: '#fff', fontWeight: '600' }}>
          Competitors for "{keyword}"
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{
        backgroundColor: '#2a2c38',
        color: '#fff',
        padding: '0',
        maxHeight: '70vh',
        overflowY: 'auto'
      }}>
        {competitorItems.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '40px 20px',
            color: '#888'
          }}>
            No competitors data available
          </div>
        ) : (
          <div style={{ padding: '0' }}>
            {competitorItems.map((item, index) => (
              <div
                key={item.itemId}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '16px 20px',
                  borderBottom: '1px solid #3a3c46',
                  transition: 'background-color 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#3a3c46';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                {/* Avatar - Clickable */}
                <div
                  style={{
                    width: '45px',
                    height: '45px',
                    marginRight: '16px',
                    borderRadius: '8px',
                    flexShrink: 0,
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease',
                    backgroundColor: '#4a4c56',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#fff',
                    overflow: 'hidden'
                  }}
                  onClick={() => handleGameClick(item.itemId)}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  {item.imageUrl ? (
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    item.name ? item.name.charAt(0).toUpperCase() : '?'
                  )}
                </div>

                {/* Game Title and Downloads */}
                <div style={{
                  flex: 1,
                  minWidth: 0
                }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#fff',
                    marginBottom: '4px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {item.name}
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#F6255A',
                    fontWeight: '600'
                  }}>
                    {formatDownloads(item.downloads)} downloads
                  </div>
                </div>

                {/* Rank Number */}
                <div style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#F6255A',
                  minWidth: '30px',
                  textAlign: 'right'
                }}>
                  #{index + 1}
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CompetitorsModal;
